import React from 'react';
import type { ReactNode } from 'react';

import Header from '../Header/Header';
import UsersList from '../UsersList/UsersList';

import './Identities.css';

function Identities({
  header,
  actionsMenu,
}: {
  header?: ReactNode;
  actionsMenu?: ReactNode;
}) {
  return (
    <div className='Ext-Identities'>
      <div className='Ext-Identities-header-content'>
        {header ?? <Header />}
      </div>
      <UsersList actionsMenu={actionsMenu} />
    </div>
  );
}

Identities.defaultProps = { header: undefined, actionsMenu: undefined };

export default Identities;
